export function zendeskChangeLanguage(language) {
  var waitForZopim = setInterval(function () {
    if (window.$zopim === undefined || window.$zopim.livechat === undefined) {
      return;
    }
    $zopim(function () {
      $zopim.livechat.setLanguage(language);
      $zopim.livechat.theme.setColor('#008cf3');
    });
    clearInterval(waitForZopim);
  }, 100);
}


export function zendeskLogIn(userName, userEmail) {
  // zE('webWidget', 'prefill', {
  //   name: {
  //     value: userName,
  //     readOnly: true
  //   },
  //   email: {
  //     value: userEmail,
  //     readOnly: true
  //   }
  // });
}

export function zendeskLogOut() {
  // zE('webWidget', 'reset');
  // zE('webWidget', 'prefill', {
  //   name: {
  //     value: '',
  //     readOnly: false
  //   },
  //   email: {
  //     value: '',
  //     readOnly: false
  //   }
  // });
}

export function zendeskHide() {
  // zE('webWidget', 'hide');
}
